export default function resolveElement(element) {
  if (element instanceof Element) return element;

  if (typeof element === 'string') {
    const queryResults = document.querySelector(element);
    if (queryResults) return element;

    const byId = document.getElementById(element);
    if (byId) return byId;
  }
  return null;
}
